import { render, staticRenderFns } from "./MeetingForm.vue?vue&type=template&id=c620804a&"
import script from "./MeetingForm.vue?vue&type=script&lang=js&"
export * from "./MeetingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports